/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da700306fe9346a3fbf34e0d7fc8a9b5>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Card".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/card
 * Usage guidance:
 * Known uses: Representing cards in Trello. Toggling card detail in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const CardIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "CardIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V9h11v4a.5.5 0 0 1-.5.5zm10.5-6h-11V3a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5zM4 12h5v-1.5H4zm6.5 0H12v-1.5h-1.5z" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
CardIcon.displayName = 'CardIcon';
var _default = exports.default = CardIcon;